import { memo } from 'react'
import VersionDisplay from 'components/VersionDisplay'
import TvLogoBanner from 'components/TvLogoBanner'
import ProgressIndicatorSkeleton from 'components/Smava/ProgressIndicator/Skeleton'
import ReturningVisitorSkeleton from 'components/ReturningVisitor/ReturningVisitorSkeleton'
import PageLayout from 'components/Layout/Page'
import PersonalSkeleton from 'containers/PersonalSkeleton'
import CategoryLayout from 'components/Layout/Category'

const SkeletonView = () => {
  return (
    <>
      <TvLogoBanner />
      <PageLayout>
        <CategoryLayout>
          <ProgressIndicatorSkeleton />
          <ReturningVisitorSkeleton />
          <PersonalSkeleton />
        </CategoryLayout>
      </PageLayout>
      <VersionDisplay />
    </>
  )
}

export default memo(SkeletonView)
